export function paddingZero(num, padding = 2) {
  let len = Math.floor(num).toString().length;
  while (len < padding) {
    num = "0" + num;
    len++;
  }
  return num;
}
/**
 * 度转度分秒
 * @param {Number} value 度数
 * @param {Object} config 配置信息
 * @returns
 */
export function formatDegree(
  value,
  config = {
    degreeDecimal: 6,
    minuteDecimal: 2,
    secondDecimal: 2,
  }
) {
  let absValue = Math.abs(value);
  let degree = Math.floor(absValue);
  let minute = (absValue - degree) * 60;
  let second = ((absValue - degree) * 3600) % 60;

  let result = {
    value: `${degree}°${paddingZero(Math.floor(minute))}′${paddingZero(
      second.toFixed(config.secondDecimal)
    )}″`,
    degreeMinute: `${degree}°${minute.toFixed(config.minuteDecimal)}'`,
    originValue: value,
    degree: Number(value).toFixed(config.degreeDecimal),
    minute: ((value - degree) * 60).toFixed(config.minuteDecimal),
    second: (((value - degree) * 3600) % 60).toFixed(config.secondDecimal),
  };
  return result;
}

/**
 * 经纬度格式化
 * @param { Number } longitude 经度
 * @param { Number } latitude 纬度
 * @param { Object } config 配置信息
 * @returns
 */
export function formatLatitudeAndLongitude(
  longitude,
  latitude,
  config = {
    degreeDecimal: 4,
    minuteDecimal: 2,
    secondDecimal: 4,
  }
) {
  let fmtLongitude = formatDegree(longitude, config);
  let fmtLatitude = formatDegree(latitude, config);
  const lonName = longitude >= 0 ? "东经" : "西经";
  const latName = latitude >= 0 ? "北纬" : "南纬";
  const lonFlag = longitude >= 0 ? "E" : "W";
  const latFlag = latitude >= 0 ? "N" : "S";
  return {
    longitude: {
      textCn: `${lonName} ${fmtLongitude.degreeMinute}`,
      textEn: `${fmtLongitude.degreeMinute} ${lonFlag}`,
      get value() {
        return this.fmtValue.value;
      },
      get completeValue() {
        return `Lon. ${this.value} ${this.nameEn}`;
      },
      fmtValue: fmtLongitude,
      name: lonName,
      nameEn: lonFlag,
    },
    latitude: {
      textCn: `${latName} ${fmtLatitude.degreeMinute}`,
      textEn: `${fmtLatitude.degreeMinute} ${latFlag}`,
      get value() {
        return this.fmtValue.value;
      },
      get completeValue() {
        return `Lat. ${this.value} ${this.nameEn}`;
      },
      fmtValue: fmtLatitude,
      name: latName,
      nameEn: latFlag,
    },
  };
}

/**
 * 计算两经纬度点之间的距离(单位：米)
 * @param p1 起点的坐标；[经度,纬度]；
 * @param p2 终点的坐标；[经度,纬度]；
 *
 * @return d 返回距离
 */
export const getPointDistance = (p1, p2) => {
  const rlat1 = (p1[1] * Math.PI) / 180.0;
  const rlat2 = (p2[1] * Math.PI) / 180.0;
  const a = rlat1 - rlat2;
  const b = (p1[0] * Math.PI) / 180.0 - (p2[0] * Math.PI) / 180.0;
  let d =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  d = d * 6378.137;
  d = Math.round(d * 10000) / 10;
  return d;
};
/**
 * 度分 > 度
 * @param {any} v 度分的值
 * @param {any} lngOrlat 是经度还是纬度,经度的度要补足前三位,纬度不需要
 * @param {any} xsdLnegth 度最后小数点保留位数
 */
export function DM_DD(v, lngOrlat = "lng", xsdLnegth = 6) {
  if (typeof v == "undefined" || v == "") {
    return "";
  }
  var duLen = lngOrlat == "lng" ? 3 : 2; //度的补足位数,经度是3位,纬度是2位
  v = v.toString();
  var reg = /[\d|.]+/gi;
  v = v.match(reg);
  var str;
  var d, m, mm;
  d = parseInt(v[0], 10);
  m = v[1].toString();
  if (v.length == 3) {
    mm = v[2];
    m += mm.toString();
  }
  m = formatFloat(parseFloat(m) / 60, xsdLnegth);
  str = d.toString().padEnd(duLen, "0") + "." + m.toString().substr(2);
  return str;
}
function formatFloat(f, digit) {
  if (digit == null) digit = 2;
  var m = Math.pow(10, digit);
  var s = (f * m).toFixed(digit);
  s = parseFloat(s);
  return parseInt(s, 10) / m;
}
